import dayjs from "dayjs";

export default class Dates {
  constructor(params) {
    const date = params ? dayjs(params) : dayjs();

    return date.second(0).millisecond(0);
  }
}
